import { render, staticRenderFns } from "./SliceAuctions.vue?vue&type=template&id=870f1212&lang=pug&"
import script from "./SliceAuctions.vue?vue&type=script&lang=js&"
export * from "./SliceAuctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports